<template>
  <div>
    <a-modal
      centered
      :maskClosable="false"
      title="功能权限"
      v-model="visible"
      width="70%"
      @ok="handleOk"
    >
      <div>
        <a-layout id="components-layout-demo-side" style="height: 100%">
          <a-layout-sider>
            <a-tree
              style="overflow:auto;height:100%"
              :treeData="treeData"
              @select="onSelect"
              :selectedKeys.sync="selectedKeys"
            ></a-tree>
          </a-layout-sider>
          <a-layout>
            <div>
              <div style="padding:8px;background: white;">
                <a-button
                  style="margin-left:5px"
                  type="primary"
                  @click="selectAll(true)"
                  >全选</a-button
                >
                <a-button
                  style="margin-left:10px"
                  type="primary"
                  @click="selectAll(false)"
                  >取消全选</a-button
                >
              </div>
              <data-grid
                :columns="columns"
                v-model="dataShow"
                rowKey="Code"
                bordered
              />
              <!-- {{data}} -->
            </div>
          </a-layout>
        </a-layout>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";

export default {
  name: "roleQermission",
  components: { DataGrid },
  props: {
    roleId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      selectedKeys: [],
      treeData: [],
      data: [],
      dataShow: [],
      params: {},
      columns: [
        {
          title: "名称",
          dataIndex: "Name",
          width: "20%"
        },
        {
          title: "操作",
          dataIndex: "Permissions",
          width: "80%",
          align: "left",
          customRender: text => {
            if (text) {
              var str = text.map(item => {
                if (typeof item.Checked !== "boolean") {
                  item.Checked = false;
                }
                return (
                  <a-checkbox
                    value={item.Code}
                    check={item.Checked}
                    v-model={item.Checked}
                  >
                    {item.Name}
                  </a-checkbox>
                );
              });
              return str;
            }
          }
        }
      ]
    };
  },
  created() {
    this.$post("Role_GetPermissionModules", {}).then(res => {
      let arr = [{ key: 0, title: "全部" }];
      res.Data.forEach(item => {
        arr.push({ key: item.Code, title: item.Name });
      });
      this.treeData = arr;
    });
    this.$post("Role_GetRolePermissions", { Id: this.roleId }).then(res => {
      this.data = res.Data;
      this.dataShow = this.data;
    });
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    onCancel() {
      this.$emit("destroy");
    },
    //选择的树节点
    onSelect(selectedKeys) {
      this.dataShow = [];
      if (selectedKeys == "0") this.dataShow = this.data;
      else {
        this.data.forEach(item => {
          if (item.ParentPermissionModuleCode == selectedKeys)
            this.dataShow.push(item);
        });
      }
    },
    selectAll(value) {
      this.dataShow.forEach(item => {
        item.Permissions.forEach(el => {
          el.Checked = value;
        });
      });
    },
    handleOk() {
      let json = { RoleId: this.roleId, PermissionCodes: [] };
      this.data.forEach(item => {
        item.Permissions.forEach(el => {
          if (el.Checked) {
            json.PermissionCodes.push(el.Code);
          }
        });
      });
      this.$post("Role_SetPermissions", json).then(() => {
        this.$message.info("操作成功");
        this.visible = false;
      });
    }
  },
  // 计算属性
  computed: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
</style>
